import { UploadableFileType } from '@omnea-app/packages/universal/form/elements/files'
import { FormPage } from '@omnea-app/packages/universal/formBuilder/form'
import { FormTemplatesInsertInput, FormTemplateStateEnum, FormTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

export const CreditsafeQuestionIds = {
  registeredCompanyName: 'registeredCompanyName',
  currentNumberOfEmployees: 'currentNumberOfEmployees',
  previousNumberOfEmployees: 'previousNumberOfEmployees',
  yearsInOperation: 'yearsInOperation',
  currentCreditRatingCommonValue: 'currentCreditRatingCommonValue',
  currentCreditRatingLocalCreditScore: 'currentCreditRatingLocalCreditScore',
  previousCreditRatingLocalCreditScore: 'previousCreditRatingLocalCreditScore',
  currentContractLimit: 'currentContractLimit',
  currentCreditRatingProbabilityOfDefault: 'currentCreditRatingProbabilityOfDefault',
  currentBalanceSheetCash: 'currentBalanceSheetCash',
  previousBalanceSheetCash: 'previousBalanceSheetCash',
  currentBalanceSheetTotalAssets: 'currentBalanceSheetTotalAssets',
  previousBalanceSheetTotalAssets: 'previousBalanceSheetTotalAssets',
  currentBalanceSheetTotalLiabilities: 'currentBalanceSheetTotalLiabilities',
  previousBalanceSheetTotalLiabilities: 'previousBalanceSheetTotalLiabilities',
  currentBalanceSheetTotalShareholdersEquity: 'currentBalanceSheetTotalShareholdersEquity',
  previousBalanceSheetTotalShareholdersEquity: 'previousBalanceSheetTotalShareholdersEquity',
  creditsafeGeneratedReport: 'creditsafeGeneratedReport',
}

// TODO (INT-508): Migrate this to use form template questions to lock down the question IDs
export const formTemplate: FormTemplatesInsertInput = {
  title: 'CreditSafe Report',
  state: FormTemplateStateEnum.PUBLISHED,
  type: FormTypeEnum.EXTERNAL_OPERATION,
  integration: 'creditsafe',
  description: 'This form is used to capture the output of the CreditSafe integration',
  config: {
    logic: {},
    pages: [
      {
        id: '58c141cd-2fa5-4811-a868-384b2db05010',
        name: 'overview',
        title: 'Company Details',
        questions: [
          {
            id: '11a791ef-1d6e-4ad9-9684-910fee88c718',
            name: CreditsafeQuestionIds.registeredCompanyName,
            type: 'text',
            title: "What is your organisation's registered name?",
            visibleIf: [],
            isRequired: false,
            description: 'Please specify the full registered name',
          },
          {
            id: 'f89a3a9b-6e5e-4b37-b3ae-12cfe5be86be',
            name: CreditsafeQuestionIds.currentNumberOfEmployees,
            type: 'number',
            title: 'How many employees work in the company?',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: '0f47b6aa-e6c2-44c3-aef2-5e29a604fde2',
            name: CreditsafeQuestionIds.previousNumberOfEmployees,
            type: 'number',
            title: 'How many employees worked in the company last year?',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: 'a768071e-19c1-42cc-853a-deba2a05e6b9',
            name: CreditsafeQuestionIds.yearsInOperation,
            type: 'number',
            title: 'How many years has the company been in business?',
            visibleIf: [],
            isRequired: false,
          },
        ],
      },
      {
        id: 'dcd12592-74c0-42b5-a84f-7647dcb733c4',
        name: 'risk-overview',
        title: 'Risk Overview',
        questions: [
          {
            id: '146fffaf-b93b-46ba-a520-28eee96da007',
            name: CreditsafeQuestionIds.currentCreditRatingCommonValue,
            type: 'text',
            title: 'What is the international risk score?',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: '27ef48b2-e09f-4e9a-8d3b-cda0bdd68156',
            name: CreditsafeQuestionIds.currentCreditRatingLocalCreditScore,
            type: 'number',
            title: 'What is the local risk score?',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: '1ad77155-55a7-4f28-9660-2b98b102b275',
            name: CreditsafeQuestionIds.previousCreditRatingLocalCreditScore,
            type: 'number',
            title: 'What was the local risk score last year?',
            visibleIf: [],
            isRequired: false,
          },
          {
            id: '9cbb4c5e-9d05-497e-bd06-d56c2798b984',
            name: CreditsafeQuestionIds.currentContractLimit,
            type: 'price',
            title: 'What is the advised contract limit?',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '4f9baed9-7ddf-43a3-a299-8f4fb25a9215',
            name: CreditsafeQuestionIds.currentCreditRatingProbabilityOfDefault,
            type: 'text',
            title: 'What is the probability of default?',
            visibleIf: [],
            isRequired: false,
          },
        ],
        visibleIf: [],
      },
      {
        id: '5c3622d6-c03a-4d9b-ac63-ea8c6ebf54b2',
        name: 'financial-health',
        title: 'Financial Health',
        questions: [
          {
            id: '213ac106-f4ba-42a1-952f-e565ae6f9751',
            name: CreditsafeQuestionIds.currentBalanceSheetCash,
            type: 'price',
            title: 'Cash',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '53fa3fbf-ad22-419c-a07f-e8dbbe226861',
            name: CreditsafeQuestionIds.previousBalanceSheetCash,
            type: 'price',
            title: 'Cash last year',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'b9b7bd53-a93f-4f49-ac8f-b424127c80fe',
            name: CreditsafeQuestionIds.currentBalanceSheetTotalAssets,
            type: 'price',
            title: 'Total Assets',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '6f25dc1c-4c3e-4397-b186-2e6161613598',
            name: CreditsafeQuestionIds.previousBalanceSheetTotalAssets,
            type: 'price',
            title: 'Total Assets last year',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'fcbff0a6-a614-4714-8556-ebd4e2cd1eee',
            name: CreditsafeQuestionIds.currentBalanceSheetTotalLiabilities,
            type: 'price',
            title: 'Total Liabilities',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'd926d41a-b8a4-4fa0-b5bd-369ef489707d',
            name: CreditsafeQuestionIds.previousBalanceSheetTotalLiabilities,
            type: 'price',
            title: 'Total Liabilities last year',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '180e7d49-4429-4777-98f7-22e78610f5cd',
            name: CreditsafeQuestionIds.currentBalanceSheetTotalShareholdersEquity,
            type: 'price',
            title: 'Shareholders Equity',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: 'bb96fa73-8327-4ca4-95ac-9d5e1348fbf6',
            name: CreditsafeQuestionIds.previousBalanceSheetTotalShareholdersEquity,
            type: 'price',
            title: 'Shareholders Equity last year',
            visibleIf: [],
            isRequired: true,
          },
          {
            id: '8d6c484f-43f8-415d-b9f1-855c94dbcfb4',
            name: CreditsafeQuestionIds.creditsafeGeneratedReport,
            type: 'files',
            title: 'Full report',
            visibleIf: [],
            isRequired: false,
            multipleFiles: true,
            supportedTypes: [UploadableFileType.PDF],
            storeFilesGlobally: true,
          },
        ],
      },
    ],
    enableAiSummary: true,
  },
}

export const CreditsafeQuestionTemplatesArray = formTemplate.config.pages.flatMap((page: FormPage) => page.questions)
export const CreditsafeQuestionIdsArray = Object.values(CreditsafeQuestionIds)
